export const mode = {
    where : 'internal',
    source : 'adsb',
    defaultMap : 'Sat',
}